{% block hueb_seo %}
<sw-page class="hueb-seo">

    {% block hueb_seo_smart_bar %}
        <template #smart-bar-header>
            {% block hueb_seo_smart_bar_header_title %}
            <h2> {{ $tc('hueb-seo.general.mainMenuItemGeneral') }} </h2>
            {% endblock %}
        </template>

        <template #language-switch>
            {% block hueb_seo_language_switch %}
            <sw-language-switch
                @on-change="onChangeLanguage">
            </sw-language-switch>
            {% endblock %}
        </template>

        <template #smart-bar-actions>
            {% block hueb_seo_smart_bar_actions_generate %}
            <sw-button-process
                :isLoading="isLoadingGenerate"
                :processSuccess="processSuccess"
                :disabled="checkedElementsBool"
                variant="primary"
                @process-finish="saveFinish"
                @click="onClickGenerate">
                {{ $tc('hueb-seo.general.generateButtonText') }}
            </sw-button-process>
            {% endblock %}
        </template>
    {% endblock %}

    <template #side-content>
        {% block hueb_seo_side_content %}
        <hueb-seo-category-tree
            :categoryId="categoryId"
            :currentLanguageId="currentLanguageId"
            @check-item="checkItem"
            @click-item="clickItem">
        </hueb-seo-category-tree>
        {% endblock %}
    </template>

    {% block hueb_seo_content %}
        <template #content>
            <sw-card-view>
                {% block hueb_seo_content_title %}
                    <h2> {{ $tc('hueb-seo.general.mainMenuItemCategory') }} </h2>
                {% endblock %}
                {% block hueb_seo_content_inner %}

                    {% block hueb_seo_options_card %}
                        <sw-card :title="$tc('hueb-seo.card.labelOptions')">
                            <sw-container columns="1fr 1fr" gap="0px 30px">
                                <sw-switch-field :label="$tc('hueb-seo.card.labelChildSwitch')"
                                                 v-model:value="includeChildren">
                                </sw-switch-field>
                                <sw-switch-field :label="$tc('hueb-seo.card.labelOverwriteSwitch')"
                                                 v-model:value="overwrite">
                                </sw-switch-field>
                            </sw-container>
                            <mt-select
                                :placeholder="$tc('hueb-seo.card.placeholderTemplateOption')"
                                :label="$tc('hueb-seo.card.labelLoadTemplate')"
                                v-model="templateSelected"
                                @update:model-value="onSelectTemplate"
                                :options="templateOptions">
                            </mt-select>
                            <sw-button
                                :isLoading="isLoadingTemplate"
                                :disabled="!templateSelected"
                                variant="primary"
                                @click="onClickSaveTemplate">
                                {{ $tc('hueb-seo.general.saveTemplateButtonText') }}
                            </sw-button>
                            <sw-button
                                :disabled="!templateSelected"
                                variant="danger"
                                @click="onClickDeleteTemplate">
                                {{ $tc('hueb-seo.general.deleteTemplateButtonText') }}
                            </sw-button>
                        </sw-card>
                    {%  endblock %}

                    {% block hueb_seo_progress_card %}
                        <sw-card :title="$tc('hueb-seo.card.labelProgress')" v-show="isBig">
                            <sw-progress-bar :value="bigProgress" :maxValue="100">
                            </sw-progress-bar>
                        </sw-card>
                    {% endblock %}

                    {% block hueb_seo_meta_card %}
                        <sw-card :title="$tc('hueb-seo.card.labelMeta')">
                            <template #grid>
                                <sw-container rows="auto auto">
                                    <sw-card-section divider="bottom">
                                        {% block hueb_seo_form %}
                                            <sw-container columns="50fr 20fr 1fr" gap="0px 30px">
                                                {% block hueb_seo_form_meta_title %}
                                                    <mt-text-field
                                                        :label="$tc('hueb-seo.card.labelMetaTitle')"
                                                        :placeholder="$tc('hueb-seo.card.placeholderMetaTitle')"
                                                        :disabled="!metaTitleActive"
                                                        @update:model-value="onChangeMetaTitle"
                                                        v-model="metaTitle">
                                                    </mt-text-field>
                                                    {% block hueb_seo_form_meta_title_options %}
                                                        <sw-single-select
                                                            :options="categoryOptions"
                                                            :placeholder="$tc('sw-seo-url-template-card.general.placeholderSelectVariables')"
                                                            :disabled="!metaTitleActive"
                                                            @update:value="onSelectMetaTitleVariable"
                                                            :label="$tc('sw-seo-url-template-card.general.labelPossibleValues')">
                                                        </sw-single-select>
                                                    {% endblock %}
                                                    <sw-switch-field
                                                        v-model:value="metaTitleActive">
                                                    </sw-switch-field>
                                                {% endblock %}
                                            </sw-container>

                                            <sw-container columns="50fr 20fr 1fr" gap="0px 30px">
                                                {% block hueb_seo_form_meta_description %}
                                                    <mt-textarea
                                                        :label="$tc('hueb-seo.card.labelMetaDescription')"
                                                        :placeholder="$tc('hueb-seo.card.placeholderMetaDescription')"
                                                        :disabled="!metaDescriptionActive"
                                                        @update:model-value="onChangeMetaDescription"
                                                        v-model="metaDescription">
                                                    </mt-textarea>
                                                    {% block hueb_seo_form_meta_descriptions_options %}
                                                        <sw-single-select
                                                            :options="categoryOptions"
                                                            :placeholder="$tc('sw-seo-url-template-card.general.placeholderSelectVariables')"
                                                            :disabled="!metaDescriptionActive"
                                                            @update:value="onSelectMetaDescriptionVariable"
                                                            :label="$tc('sw-seo-url-template-card.general.labelPossibleValues')">
                                                        </sw-single-select>
                                                    {% endblock %}
                                                    <sw-switch-field
                                                        v-model:value="metaDescriptionActive">
                                                    </sw-switch-field>
                                                {% endblock %}
                                            </sw-container>

                                            <sw-container columns="50fr 20fr 1fr" gap="0px 30px">
                                                {% block hueb_seo_form_keywords %}
                                                    <mt-text-field
                                                        :label="$tc('hueb-seo.card.labelKeywords')"
                                                        :placeholder="$tc('hueb-seo.card.placeholderKeywords')"
                                                        :disabled="!keywordsActive"
                                                        v-model="keywords"
                                                        @update:model-value="onChangeKeywords">
                                                        <sw-checkbox-field v-model:value="keywordsActive"></sw-checkbox-field>
                                                    </mt-text-field>
                                                    {% block hueb_seo_form_metaTitle_options %}
                                                        <sw-single-select
                                                            :options="categoryOptions"
                                                            :placeholder="$tc('sw-seo-url-template-card.general.placeholderSelectVariables')"
                                                            :disabled="!keywordsActive"
                                                            @update:value="onSelectKeywordsVariable"
                                                            :label="$tc('sw-seo-url-template-card.general.labelPossibleValues')">
                                                        </sw-single-select>
                                                    {% endblock %}
                                                    <sw-switch-field
                                                        v-model:value="keywordsActive">
                                                    </sw-switch-field>
                                                {% endblock %}
                                            </sw-container>
                                            <div v-if="keywordsPreview">{{ keywordsPreview }}</div><br>
                                        {% endblock %}
                                    </sw-card-section>
                                    <sw-card-section>
                                        {% block hueb_seo_serp %}
                                            <div>{{ $tc('hueb-seo.general.labelSerp') }}</div><br>
                                            <div class="hueb-seo__preview">
                                                <span class="hueb-seo__metaTitle">{{ metaTitlePreview }}</span><br>
                                                <span class="hueb-seo__seoUrl">{{ seoUrl }}</span><br>
                                                <span class="hueb-seo__metaDescription">{{ metaDescriptionPreview }}</span><br>
                                            </div>
                                        {% endblock %}
                                    </sw-card-section>
                                </sw-container>
                            </template>
                        </sw-card>
                    {% endblock %}

                    {% block hueb_seo_robot_tags %}
                        <sw-card>
                            <mt-select
                                :placeholder="$tc('hueb-seo.card.placeholderRobotTags')"
                                :label="$tc('hueb-seo.card.labelRobotTags')"
                                v-model="robotSelected"
                                :options="robotOptions">
                            </mt-select>
                        </sw-card>
                    {% endblock %}

                    {% block hueb_seo_new_template_card %}
                        <sw-card>
                            <mt-text-field
                                v-model="templateName"
                                :label="$tc('hueb-seo.card.labelTemplateName')"
                                :placeholder="$tc('hueb-seo.card.placeholderTemplateName')"
                            />

                            <sw-button
                                :isLoading="isLoadingNewTemplate"
                                :disabled="!templateName"
                                variant="primary"
                                @click="onClickSaveNewTemplate">
                                {{ $tc('hueb-seo.general.saveNewTemplateButtonText') }}
                            </sw-button>
                        </sw-card>
                    {% endblock %}

                    {% block hueb_seo_help_card %}
                        <sw-card :title="$tc('hueb-seo.card.labelHelp')">
                            <div class="hueb_seo_bulk_help">
                                {{ $tc('hueb-seo.description.textHelp') }}
                            </div>
                        </sw-card>
                    {% endblock %}

                {% endblock %}
            </sw-card-view>
        </template>
    {% endblock %}

</sw-page>
{% endblock %}
